'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _loginModal = require('./login-modal');

var _loginModal2 = _interopRequireDefault(_loginModal);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LogInTrigger = _react2['default'].createClass({
    displayName: 'LogInTrigger',


    propTypes: {
        'header': _react2['default'].PropTypes.string.isRequired,
        'linkText': _react2['default'].PropTypes.string,
        'trigger': _react2['default'].PropTypes.element,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string,
        'loginUrl': _react2['default'].PropTypes.string.isRequired,
        'redirectUrl': _react2['default'].PropTypes.string,
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool,
        'hideGoogleOpenId': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {

        var self = this;

        if (window.handlingLogInTriggers) {
            // We only want to process this once per page
            return;
        }
        // If the 'login=1' URL parameter is present, display the modal
        if (/\?display_login\=1|&display_login\=1/i.test(location.href)) {
            window.handlingLogInTriggers = true;
            this.handleClick();
        }

        // Listen for trigger events
        $(document).bind('login-trigger', function (evt, params) {
            self.handleClick(null, null, {
                'displayCaptcha': params && params.displayCaptcha || false
            });
        });
    },
    handleClick: function handleClick(evt, react_id, extraProps) {
        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('login_modal');
        var props = extraProps ? _hfReactHelper2['default'].extend({}, this.props, extraProps) : this.props;
        _reactDom2['default'].render(_react2['default'].createElement(_loginModal2['default'], {
            header: props.header,
            buttonText: props.buttonText,
            googleOpenIdUrl: props.googleOpenIdUrl,
            isFromApiPricing: props.isFromApiPricing,
            tabOffset: tabOffset,
            recaptchaPublicKey: props.recaptchaPublicKey,
            displayCaptcha: props.displayCaptcha,
            emailAddress: props.emailAddress,
            loginUrl: props.loginUrl,
            recoverPasswordForm: props.recoverPasswordForm,
            redirectUrl: props.redirectUrl,
            loginForm: props.loginForm,
            hideRememberMe: props.hideRememberMe,
            hideGoogleOpenId: props.hideGoogleOpenId }), attachPoint);
    },
    renderTrigger: function renderTrigger() {
        if (this.props.trigger) {
            return this.props.trigger;
        } else {
            return _react2['default'].createElement(
                'a',
                { href: '#' },
                this.props.linkText
            );
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'span',
            { className: 'log-in-trigger', onClick: this.handleClick },
            this.renderTrigger()
        );
    }
});

module.exports = LogInTrigger;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-trigger.jsx
 ** module id = 875
 ** module chunks = 0
 **/